export default __webpack_public_path__ + "static/media/thrive.b93fc5d7.png";